import * as PIXI from "pixi.js";
import PixiScene from "../PixiScene";

export default class PixiDebug extends PIXI.Container {

    private readonly scene: PixiScene;
    private readonly mat = new PIXI.Sprite(PIXI.Texture.WHITE);
    private text = '#113 18.04.22 v:1 Seats on table';
    private debugText: PIXI.Text;

    constructor(scene: PixiScene) {
        super();
        console.log('%c ### Debug:', 'color: #f0f', this.text);
        this.name = 'debugContainer';
        this.scene = scene;
        this.visible = false;

        this.addChild(this.mat);
        this.mat.alpha = 0.5;
        this.mat.position.set(6, 6);
        this.mat.tint = 0x35654d;

        const textStyle = new PIXI.TextStyle({
            fontFamily: 'monospace',
            fontSize: 14,
            fill: 0xffffff,
        });

        this.debugText = new PIXI.Text('', textStyle);
        this.addChild(this.debugText);
        this.debugText.position.set(16, 64);
        this.log(this.scene.platform);

        const isWebGLSupported = PIXI.utils.isWebGLSupported();
        if (!isWebGLSupported) {
            this.mat.tint = 0xffffff;
            this.mat.tint = 0xff0000;
            this.log('WebGL is not Supported');
            this.visible = true;
        }

    }

    private f(value: number, digits = 0): string
    {
        return value.toFixed(digits);
    }

    public log(value: string, nl = true): PixiDebug
    {
        // if (this.visible) {
        this.text += nl ? '\r\n' : ' ';
        this.text += value;
        this.debugText.text = this.text;
        this.mat.width  = this.debugText.width  + 40;
        this.mat.height = this.debugText.height + 80;
        // }
        return this;
    }

    public f0(value: number): PixiDebug
    {
        return this.log(this.f(value), false);
    }

    public f2(value: number): PixiDebug
    {
        return this.log(this.f(value, 2), false);
    }

    public f3(value: number): PixiDebug
    {
        return this.log(this.f(value, 3), false);
    }

}
